import { Navigate } from "react-router-dom";
import { usePathLync } from "@/pathlync/PathLyncAuth";
import LabDashboard from "@/pages/pathlync/LabDashboard";
import PathologistDashboard from "@/pages/pathlync/PathologistDashboard";
import { Loader2 } from "lucide-react";

export default function PathLyncDashboard() {
  const { user, checking } = usePathLync();
  if (checking) {
    return <div className="grid min-h-screen place-items-center bg-slate-50">
      <Loader2 className="animate-spin text-slate-400" size={26} />
    </div>;
  }
  if (!user) return <Navigate to="/pathlync" replace />;
  return user.role === "pathologist" ? <PathologistDashboard /> : <LabDashboard />;
}
